export default "__VITE_ASSET__WyA_jtZq__"